import React, { memo } from 'react'
import { Card, Divider, Link, ListItemText, Stack } from '@mui/material'
import { faSwapArrows } from '@fortawesome/pro-duotone-svg-icons'

import Text from '../text/Text'
import FaIcon from '../shared/faIcon/FaIcon'
import ExchangeProviderIcon from '../shared/exchangeProviderCard/ExchangeProviderIcon'
import AccountStatusLabel from '../manageAccounts/AccountStatusLabel'
import {
  buildDonationWebsiteUrl,
  exchangeLabelForAccount,
  isTokenTypeDonation
} from '../../util/pointsExchange.helpers'
import SubmitButton from '../shared/button/SubmitButton'
import ConnectAccountField from '../manageAccounts/ConnectAccountField'
import CustomForm from '../shared/inputs/CustomForm'
import { EXCHANGE_PROVIDER_PROFILE_DISPATCH } from '../../store/reducers/exchange/exchangeProviders'
import customConfig from 'customConfig'
import { COE_BRAND_IDS } from '../../constants/exchangeProvider'
import { openBlankRedirectPage } from '../../util/app/app.helpers'
import {
  buildViewShopUrl,
  coeBrandShopUrl
} from '../../util/navigation.helpers'
import { openExternalUrl } from '../../libs/qb-brand-web-components'

const ConnectExchangeProvider = ({
  t,
  provider,
  tokenProfile: { symbol },
  ...restProps
}) => {
  return (
    <Card sx={{ textAlign: 'center', width: 1 }}>
      {provider ? (
        <ConnectProviderStatus t={t} provider={provider} {...restProps} />
      ) : (
        <Stack
          spacing={3}
          sx={{
            p: { xs: 3, md: 5 },
            alignItems: 'center',
            justifyContent: 'center',
            height: 1
          }}
        >
          <FaIcon icon={faSwapArrows} size='3x' />
          <Text
            variant='subtitle1'
            label={t('shop.select-an-option-exchange', { symbol })}
          />
        </Stack>
      )}
    </Card>
  )
}

export default memo(ConnectExchangeProvider)

const ConnectProviderStatus = ({
  t,
  provider,
  isConnected,
  onFormSubmit,
  onQrCodeClick,
  exchangeProviderProfile: { error, connectAccountNumber, isProcessing },
  dispatchAction,
  onClickSignup
}) => {
  const { type } = provider
  const label = exchangeLabelForAccount(t, provider)
  const isDonation = isTokenTypeDonation(type)
  const handleViewShopUrlClick = () => {
    // if (noRedemptionOptions) {
    // @TODO Quick fix, need to refactor properly
    if (isDonation) {
      openExternalUrl(buildDonationWebsiteUrl(provider))
    } else if (COE_BRAND_IDS.includes(provider.brandId)) {
      openBlankRedirectPage(coeBrandShopUrl(provider))
    } else {
      const viewShopUrl = buildViewShopUrl(provider)
      if (viewShopUrl) {
        openExternalUrl(viewShopUrl)
      }
    }
    // }
  }
  return (
    <>
      <CustomForm onFormSubmit={onFormSubmit}>
        <Stack spacing={2} alignItems='center' sx={{ p: { xs: 2, md: 4 } }}>
          <ExchangeProviderIcon provider={provider} iconSize={100} />
          <ListItemText
            primary={label}
            slotProps={{ primary: { sx: { typography: 'subtitle1' } } }}
          />
          <ConnectAccountField
            provider={provider}
            qrCodeEnabled={!isConnected}
            onQrCodeClick={onQrCodeClick}
            onChange={(value) =>
              dispatchAction(
                EXCHANGE_PROVIDER_PROFILE_DISPATCH.CONNECT_ACCOUNT_NUMBER,
                value
              )
            }
            error={t(
              error[EXCHANGE_PROVIDER_PROFILE_DISPATCH.CONNECT_ACCOUNT_NUMBER]
            )}
            value={connectAccountNumber}
            disabled={isConnected}
            // error={provider && value ? error : ''}
            // onChange={handleChange}
            // {...restProps}
            t={t}
          />
          <Stack
            direction='row'
            spacing={1}
            sx={{
              width: '100%',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <AccountStatusLabel isConnected={isConnected} t={t} />
            <SubmitButton
              size='default'
              label={isConnected ? t('shop.manage') : t('exchange.connect')}
              loading={isProcessing}
            />
          </Stack>
        </Stack>
      </CustomForm>

      <Divider sx={{ borderStyle: 'dashed' }} />

      <Stack sx={{ p: { xs: 2, md: 4 } }} spacing={2}>
        <ListItemText
          primary={t('exchange.welcome-to-shop', { targetProvider: label })}
          secondary={provider?.description || ''}
          slotProps={{ primary: { sx: { typography: 'subtitle1' } } }}
        />
        <Stack
          direction='row'
          spacing={2}
          sx={{
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Link onClick={handleViewShopUrlClick}>
            {t(customConfig.viewShopLabel)}
          </Link>
          {!isDonation && (
            <Link onClick={onClickSignup}>{t('sign-up.sign-up')} </Link>
          )}
        </Stack>
      </Stack>
    </>
  )
}
